<template>
  <MyOrdersStatusInfoButton
    v-if="status === ScratchcardState.Purchased"
    v-bind="{ status }"
    class="mr-200"
    type="scratchcard"
  />

  <MyOrdersStatusBadgeScratchcard v-bind="{ count, status }" />
</template>

<script lang="ts" setup>
import { ScratchcardState } from '#api/shared/@types/generated/backend/graphql-schema-types'

type MyOrdersStatusProps = {
  count?: number
  status: ScratchcardState
}

const { count = 0 } = defineProps<MyOrdersStatusProps>()
</script>
